module.exports = __webpack_public_path__ + "static/media/chief-Introspective.007e2425.png";